// extracted by mini-css-extract-plugin
export default {"itemsBlock":"itemsBlock_qgNpS","item":"item_LK6Xo","title":"title_wASxw"};